import { useEffect, useRef, useState } from "react"

/** Open state for a small menu: closes on a click outside or Escape, and returns focus to its button. */
export function usePopover<B extends HTMLElement = HTMLButtonElement, P extends HTMLElement = HTMLDivElement>() {
  const [open, setOpen] = useState(false)
  const button = useRef<B>(null)
  const panel = useRef<P>(null)
  useEffect(() => {
    if (!open) return
    const onDoc = (e: MouseEvent) => {
      const t = e.target as Node
      if (!panel.current?.contains(t) && !button.current?.contains(t)) setOpen(false)
    }
    const onKey = (e: KeyboardEvent) => {
      if (e.key !== "Escape") return
      e.stopPropagation()
      setOpen(false)
      button.current?.focus()
    }
    document.addEventListener("mousedown", onDoc)
    document.addEventListener("keydown", onKey, true)
    return () => {
      document.removeEventListener("mousedown", onDoc)
      document.removeEventListener("keydown", onKey, true)
    }
  }, [open])
  return { open, setOpen, button, panel }
}
